<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="d-none">
        <qr-code-make
          ref="qrCanvas"
          v-model="qrDesign"
          :file.sync="qrSvgDataUrl"
          :link="info?.link"
          @save="autoSave"
        />
        <qr-maker />
      </div>
      <div
        class="pa-2"
        style="min-height: 900px; height: 100%; max-height: 10vh"
      >
        <custom-tabs
          style="min-height: 600px; max-height: 10vh"
          v-model="tabs"
          :tab-items="[
            { text: this.$t('smart_creation'), icon: 'brain' },
            { text: this.$t('automatic_creation'), icon: 'cog' },
          ]"
          grow
        >
          <template v-slot:staticItems>
            <v-tab-item
              class="mt-8"
              :style="
                isMobile
                  ? { marginRight: '0px', marginLeft: '0px' }
                  : { marginRight: '8px', marginLeft: '8px' }
              "
            >
              <v-row
                style="justify-content: start; align-items: center"
                class="mx-5"
              >
                <v-col class="py-0 px-4" cols="12" md="6">
                  <business-type
                    @updateBusiness="updateBusiness"
                    style="padding: 0px !important"
                  />
                </v-col>
                <v-col class="py-0 px-4" cols="12" md="6">
                  <v-text-field
                    v-model="Textbusiness"
                    class="rounded-lg"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    :label="$t('business_name')"
                    :placeholder="$t('example_household_goods')"
                    outlined
                    :rules="rules"
                  />
                </v-col>
              </v-row>

              <!-- Advanced Settings Button -->
              <v-row class="mx-5 mt-4">
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="showAdvancedSettings = !showAdvancedSettings"
                    color="primary"
                    outlined
                    class="advanced-settings-btn"
                    elevation="2"
                  >
                    <v-icon class="ml-2">{{
                      showAdvancedSettings
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                    <v-icon class="mr-2">mdi-tune-vertical</v-icon>
                    {{ $t("advanced_settings") }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Advanced Settings Section -->
              <v-expand-transition>
                <div v-show="showAdvancedSettings" class="mx-5">
                  <v-card class="pa-4 mt-4" outlined>
                    <!-- نام مجموعه و نام لاتین -->
                    <v-row class="mx-2 mb-4">
                      <v-col class="py-0 px-0 pl-4" cols="12" md="6">
                        <v-text-field
                          v-model="organizationName"
                          class="rounded-lg"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          :label="$t('organization_name')"
                          :placeholder="$t('example_tech_company')"
                          outlined
                          :prepend-icon="null"
                          prepend-inner-icon="mdi-factory"
                          :rules="[
                            (v) =>
                              !v ||
                              (v && v.length >= 2) ||
                              this.$t('minimum_two_characters_required'),
                            (v) =>
                              (v && v.length <= 100) ||
                              this.$t('maximum_100_characters_allowed'),
                          ]"
                        />
                      </v-col>
                      <v-col class="py-0 pl-0 pr-4" cols="12" md="6">
                        <v-text-field
                          v-model="latinName"
                          class="rounded-lg"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          :prepend-icon="null"
                          prepend-inner-icon="mdi-web"
                          :label="$t('latin_name_qr_address')"
                          :placeholder="$t('example_advanced_tech')"
                          outlined
                          :rules="[
                            (v) =>
                              !v ||
                              (v && v.length >= 2) ||
                              this.$t('minimum_two_characters_required'),
                            (v) =>
                              !v ||
                              /^[a-zA-Z0-9\-_]+$/.test(v) ||
                              this.$t('only_english_numbers_dash_allowed'),
                            (v) =>
                              (v && v.length <= 50) ||
                              this.$t('maximum_50_characters_allowed'),
                          ]"
                          :hint="$t('latin_name_goes_after_domain')"
                          persistent-hint
                        />
                      </v-col>
                    </v-row>
                    <!-- <v-switch
                      v-model="choiceOImage"
                      :label="$t('select_logo_and_store_product_image')"
                      hide-details
                      dense
                      class="py-0 ma-0 mt-4"
                      prepend-icon="mdi-image"
                    /> -->

                    <!-- لوگو و عکس -->
                    <v-row no-gutters class="mx-2 mb-4">
                      <v-col class="pa-2 px-0 pl-4" cols="12" md="6">
                        <div class="rowinfo">
                          <v-file-input
                            v-model="files.icon"
                            :loading="logoLoading"
                            accept="image/png, image/jpg, image/jpeg"
                            dense
                            :label="$t('select_logo')"
                            class="contentinfo rounded-lg"
                            outlined
                            show-size
                            :rules="[
                              (v) =>
                                (v && v.size < 2000000) ||
                                this.$t('file_size_must_be_less_than_2mb'),
                              (v) =>
                                (v &&
                                  ['image/jpeg', 'image/png'].includes(
                                    v.type,
                                  )) ||
                                'فقط فرمت‌های JPG و PNG مجاز هستند',
                            ]"
                            ref="fileInputLogo"
                            :prepend-icon="null"
                            prepend-inner-icon="mdi-image"
                            @change="readerRead($event, 'logo')"
                            @click:prepend-inner="openFileDialog"
                          />
                        </div>
                        <div
                          v-if="files.icon"
                          class="d-flex align-start"
                          style="gap: 8px"
                        >
                          <div>
                            <h3>لوگو ۱۴۴px</h3>
                            <canvas
                              id="canvas144"
                              style="max-width: 144px; max-height: 144px"
                            ></canvas>
                          </div>
                          <div>
                            <h3>لوگو ۴۸px</h3>
                            <canvas
                              id="canvas48"
                              style="max-width: 48px; max-height: 48px"
                            ></canvas>
                          </div>
                        </div>
                      </v-col>

                      <v-col class="pt-2 pr-4 pl-0" cols="12" md="6">
                        <div class="rowinfo">
                          <v-file-input
                            v-model="files.screenshot"
                            :loading="screenshotLoading"
                            accept="image/png, image/jpg, image/jpeg"
                            dense
                            label="انتخاب تصویر فروشگاه/محصول"
                            outlined
                            show-size
                            clearable
                            :rules="[
                              (v) =>
                                (v && v.size < 2000000) ||
                                this.$t('file_size_must_be_less_than_2mb'),
                              (v) =>
                                (v &&
                                  ['image/jpeg', 'image/png'].includes(
                                    v.type,
                                  )) ||
                                'فقط فرمت‌های JPG و PNG مجاز هستند',
                            ]"
                            ref="fileInputproduct"
                            :prepend-icon="null"
                            prepend-inner-icon="mdi-image"
                            @change="readerRead($event, 'screenshot')"
                            @click:prepend-inner="openFileDialog"
                            class="rounded-lg"
                          />
                        </div>
                        <div
                          v-if="files.screenshot"
                          class="d-flex align-start flex-wrap"
                          style="gap: 8px"
                        >
                          <div>
                            <h3>عکس Wide</h3>
                            <canvas
                              id="screenshotWide"
                              style="max-width: 200px; max-height: 150px"
                            ></canvas>
                          </div>
                          <div>
                            <h3>عکس</h3>
                            <canvas
                              id="screenshot600"
                              style="max-width: 200px; max-height: 150px"
                            ></canvas>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0 px-4" cols="12" md="6">
                        <!-- انتخاب رنگ -->
                        <div class="mt-4">
                          <h5 class="mb-3">
                            <v-icon>mdi-palette</v-icon>انتخاب رنگ بندی کارت
                            ویزیت
                          </h5>
                          <color-picker-popup
                            v-model="colorPalette"
                            header-label="هدر"
                            body-label="بدنه"
                            text-label="متن"
                            @input="updateColorPalette"
                          />
                        </div>
                      </v-col>

                      <!-- افزودن اطلاعات مجموعه -->

                      <v-col class="py-0 px-4" cols="12" md="6">
                        <v-switch
                          style="padding-top: 30px !important"
                          v-model="oldDataQr"
                          label=" افزودن اطلاعات مجموعه"
                          hide-details
                          dense
                          class="py-0 ma-0"
                          prepend-icon="mdi-folder-information"
                        ></v-switch>
                        <v-radio-group v-model="radioGroup" v-if="oldDataQr">
                          <v-radio
                            label="از کیوآرهای قبلی "
                            value="mylastQr"
                          ></v-radio>
                          <v-radio label="از سایت" value="flagUrl"></v-radio>
                          <v-row v-if="radioGroup === 'mylastQr'">
                            <v-col cols="10">
                              <v-autocomplete
                                v-model="selectedQr"
                                :items="QrData"
                                :loading="qrselectloading"
                                item-text="text"
                                item-value="value"
                                label=" کیوار من"
                                outlined
                                hint="انتخاب کیوآر اختیاری است. در صورت تمایل به استفاده از اطلاعات کاربری کیوآر قبلی"
                                return-object
                                dense
                                :search-input.sync="search"
                                @change="handleSelection"
                                :no-data-text="
                                  QrData.length === 0 && !qrselectloading
                                    ? 'هیچ کیوآر کدی تا حالا نساخته‌اید'
                                    : 'در حال بارگذاری...'
                                "
                              >
                                <template v-slot:item="{ item }">
                                  <div class="d-flex row gap-3">
                                    <v-list-item-content>
                                      <v-list-item-title>{{
                                        item.text
                                      }}</v-list-item-title>
                                    </v-list-item-content>
                                  </div>
                                </template>
                                <template v-slot:selection="{ item }">
                                  {{ item.name }}
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="2" class="icon">
                              <v-img
                                src="/media/img/logo.webp"
                                lazy-src="/media/img/logo.webp"
                                class="mt-0"
                                width="40"
                                height="40"
                            /></v-col>
                          </v-row>
                          <v-row v-if="radioGroup === 'flagUrl'">
                            <v-col cols="10">
                              <v-text-field
                                v-model="url_"
                                dense
                                :error-messages="errorurl"
                                :rules="urlRules"
                                outlined
                                :placeholder="$terminalads"
                                clearable
                                v-bind="$attrs"
                                clear-icon="mdi-close-circle-outline"
                                style="direction: ltr"
                                direction="ltr"
                                label="آدرس سایت"
                              >
                              </v-text-field
                            ></v-col>
                            <v-col cols="2" class="icon2">
                              <svg-base
                                class="mt-0"
                                view-box="0 0 60 60"
                                width="50"
                                height="50"
                              >
                                <svg-location class="mt-0" /> </svg-base
                            ></v-col>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-expand-transition>

              <!-- Create Button -->
              <v-row class="mx-5 mt-4">
                <v-col cols="12" class="text-left">
                  <v-btn
                    :loading="loading"
                    :disabled="!Textbusiness"
                    class="submit-btn"
                    elevation="3"
                    @click="generatorTextAi()"
                  >
                    <v-icon class="mr-2">mdi-magic-staff</v-icon>
                    ساخت هوشمند کارت ویزیت
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Building List Section -->
              <v-row class="mx-2 mt-3">
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title
                      class="d-flex justify-space-between align-center building-list-header"
                    >
                      <div class="d-flex align-center">
                        <v-icon class="mr-2" color="primary">
                          mdi-clock-outline
                        </v-icon>
                        <span class="building-list-title"
                          >لیست در حال ساخت‌ها</span
                        >
                      </div>
                      <v-btn
                        icon
                        small
                        color="primary"
                        @click="refreshBuildingList"
                        :loading="refreshingBuildingList"
                        class="refresh-btn"
                      >
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text v-if="buildingList.length > 0">
                      <div class="notification-banner mb-4">
                        <v-alert
                          type="info"
                          border="left"
                          colored-border
                          elevation="2"
                          class="notification-alert"
                        >
                          <div class="d-flex align-center">
                            <!-- <v-icon class="mr-3" color="info">
                              mdi-information-outline
                            </v-icon> -->
                            <div class="notification-content">
                              <div class="notification-title">
                                کیوآر کد شما پس از تکمیل مراحل ساخت، به
                                <router-link
                                  to="/qr/list"
                                  class="notification-link"
                                >
                                  <span class="font-weight-bold"
                                    >لیست کیوآرهای من</span
                                  >
                                </router-link>
                                منتقل خواهد شد.
                              </div>
                              <div class="notification-subtitle">
                                می‌توانید وضعیت ساخت کیوآر کدهای خود را در اینجا
                                مشاهده کنید
                              </div>
                            </div>
                          </div>
                        </v-alert>
                      </div>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in buildingList"
                          :key="index"
                          class="mb-3 building-list-item"
                        >
                          <progress_createauto2
                            :info="item"
                            @refreshBuildingList="refreshBuildingList"
                          />
                        </v-list-item>
                      </v-list>
                      <!-- <v-list>
                        <v-list-item
                          v-for="(item, index) in buildingList"
                          :key="index"
                          class="mb-3 building-list-item"
                        >
                          <v-list-item-avatar class="mr-3">
                            <v-icon
                              :color="getStatusColor(item.data.data.auto_build)"
                              size="24"
                            >
                              {{ getStatusIcon(item.data.data.auto_build) }}
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold mb-1">
                              {{ item.title || "کارت ویزیت" }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="mb-2">
                              <v-chip
                                small
                                :color="
                                  getStatusColor(item.data.data.auto_build)
                                "
                                text-color="white"
                                class="mr-2"
                              >
                                {{ getStatusText(item.data.data.auto_build) }}
                              </v-chip>
                              <span class="text-caption grey--text">
                                {{ item.qrType || "کارت ویزیت" }}
                              </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="text-caption">
                              <v-icon small class="mr-1">mdi-link</v-icon>
                              <span class="font-family-monospace">{{
                                `qrland.in/${item.identifier}` || item.qr
                              }}</span>
                            </v-list-item-subtitle>

                            <v-divider v-if="isMobile" />
                            <v-spacer v-else />
                            <div
                              style="width: 100%"
                              v-if="
                                !!item?.data?.data?.auto_id &&
                                item?.data?.data?.auto_id !== null
                              "
                            >
                              <progress_createauto :info="item" />
                            </div>
                          </v-list-item-content>

                          <v-list-item-action class="ml-0">
                            <v-progress-circular
                              v-if="item.data.data.auto_build === 'process'"
                              :value="item.progress || 0"
                              size="40"
                              :color="getProgressColor(item.progress)"
                              width="4"
                            >
                              <span class="text-caption font-weight-bold">
                                {{ Math.round(item.progress || 0) }}%
                              </span>
                            </v-progress-circular>
                            <v-btn
                              v-else-if="
                                item.data.data.auto_build === 'success'
                              "
                              icon
                              small
                              color="success"
                              @click="viewQr(item)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              v-else-if="item.data.data.auto_build === 'error'"
                              icon
                              small
                              color="error"
                              @click="retryQr(item)"
                            >
                              <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list> -->
                    </v-card-text>

                    <v-card-text v-else class="text-center">
                      <v-icon size="48" color="grey lighten-1"
                        >mdi-clock-outline</v-icon
                      >
                      <div class="mt-2 text-grey">
                        هیچ موردی در حال ساخت نیست
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="pa-2">
              <create-auto_2 />
            </v-tab-item>
          </template>
        </custom-tabs>
      </div>
      <progress-modal2
        :show.sync="progressDialog"
        :loading="loadingbulidinglist"
        :closable="!loadingbulidinglist"
        :title="progressTitle"
        :message="progressMessage"
        :show-progress="showProgress"
        ref="progressModal"
        @onShowChange="progressDialog = $event"
      ></progress-modal2>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, RobotAxios, rbAxios, debounce } from "@/main";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import svgBase from "@/view/content/svgLoader/svgBase.vue";
import svgLocation from "@/view/content/svgLoader/svgFile/svgLocation";
import ProgressModal2 from "./ProgressModal2.vue";
import axios from "axios";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import HeaderTypeFilter from "../../list/components/headerTypeFilter.vue";
import BusinessType from "./BusinessType.vue";
import qrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import progress_createauto from "./progress_createauto.vue";
import progress_createauto2 from "./progress_createauto2.vue";

import {
  imageToPlainTextAi,
  base64ToBlob,
  saveOnCdnFiles,
} from "@/utilities/ImageGallery";

import { mapGetters } from "vuex";
import createAuto_2 from "./createAuto_2.vue";
import AdvancedColorPicker from "./AdvancedColorPicker.vue";
import ColorPickerPopup from "./ColorPickerPopup.vue";

export default {
  name: "cardvistAuto",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    createAuto_2,
    HeaderTypeFilter,
    BusinessType,
    QrCodeMake,
    ProgressModal2,
    svgBase,
    svgLocation,
    qrMaker,
    AdvancedColorPicker,
    progress_createauto,
    progress_createauto2,
    ColorPickerPopup,
  },

  data() {
    return {
      loadingbulidinglist: false,
      choiceOImage: false,
      step: 1,
      radioGroup: "mylastQr",
      oldDataQr: false,
      completeProcess: true,
      auto_build: null,
      auto_id: null,
      url_: "",
      url: "",
      flagUrl: false,
      errorurl: "",
      urlRules: [
        (v) => !v || v.length <= 100 || "حداکثر ۱۰۰ کاراکتر مجاز است",
        (v) =>
          !v ||
          this.isURL(v) ||
          " https://terminalads.com :   لینک سایت باید بصورت روبرو وارد شود",
      ],
      Ai_Text: "",
      flag: false,
      mylastQr: false,
      qrId: 0,
      qrloading: false,
      qrselectloading: false,
      selectedQr: null,
      QrData: [],
      countData: 0,
      selectedRows: false,
      tableProps: {
        page: 1,
        length: 100000,
        search: "",
        sort: "desc",
      },

      search: "",
      pagination: {},
      list: [],
      firstPage: false,
      currentPage: 1,
      loadingdata: false,
      perPage: 100000,
      page: null,
      headers: [
        { text: "ردیف", value: "index" },
        { text: "عنوان", value: "title" },
        { text: "لینک", value: "link" },
      ],
      isOldData: false,
      oldData: [],
      file: null,
      info: null,
      createdId: "",
      url: "",
      isLastPage: false,
      indexAt: -1,
      categoryName: "",
      defaultCatName: "",
      img: {
        items: {},
        categories: [],
      },
      qrSvgDataUrl: "",
      loading: false,
      orders: [
        { name: "userName" },
        { name: "workField" },
        { name: "aboutUs" },
        { name: "extraFields" },
        { name: "video_single" },

        {
          name: "video_gallery",
        },
        { name: "photo" },
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
      ],
      theme: "MobileViwer",
      destItems: [],
      dtUrl: "",
      Textbusiness: "",
      perfix_business: "",
      cardTexts: {
        audiosGallery: [],
        auto_build: null,
        auto_id: null,
        advanceSettings: {
          hasManifestIcons: true,
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: true,
            forcedSubmission: "optional",
          },
          manifest: {
            icon48: "",
            icon144: "",
            screenshotWide: "",
            screenshot600: "",
          },
        },
        customerClub: {
          title: "عضویت در باشگاه مشتریان",
          description: "",
          configs: {
            patternId: 487,
            smsType: "pattern",
            isActive: true,
            message: {
              data1: {
                state: "userInfo",
                text: "name",
              },
              data2: {
                state: "userInfo",
                text: "lastName",
              },
            },
          },
        },
        userName: "",
        workField: "",
        aboutUs: "",
        video_single: null,
        // video_single: {
        //   name: "",
        //   videos: [],
        // },
        video_gallery: [
          {
            name: "گالری ویدئو",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                url: "https://www.aparat.com/video/video/embed/videohash/a89rkt7/vt/frame",
                file_link: "https://www.aparat.com/v/a89rkt7",
                description: "",
                link: "https://www.aparat.com/v/a89rkt7",
                id: 15,
              },
            ],
          },
        ],

        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          headBackground: "/media/defaults/visitFirstDefault.webp",
          profile: "/media/defaults/qrLogo.webp",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        phoneNumber: [
          {
            number: "",
          },
        ],
        fax: "",
        location: "",
        codePostal: "",
        email: "",
        website: "",
        visitName: "کارت ویزیت",
        pallete: {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        organizationName: "",
        subOrgan: "",
        companyNumber: "",
        city: "",
        province: "",
        country: "",
        socialMedia: {},
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrDesign: {
        color: "#000000",
        background: "#FFFFFF",
        pattern: "square",
      },
      domainId: 5,
      createdDomain: "qr2.in/",
      rules: [
        (v) => !!v || "فیلد فعالیت الزامی است",
        (v) =>
          !v || this.spellChecker(v) || "متن وارد شده باید به زبان فارسی باشد!",
        (v) => (v && v.length >= 2) || "حداقل دو کاراکتر باید وارد شود!",
        (v) => {
          if (this.perfix_business !== "")
            return (
              (v && v.trim().split(" ").length >= 1) ||
              "حداقل یک کلمه وارد کنید"
            );
          else
            return (
              (v && v.trim().split(" ").length >= 2) ||
              "حداقل دو کلمه وارد کنید"
            );
        },
        (v) => (v && v.length <= 100) || "حداکثر ۱۰۰ کاراکتر مجاز است",
      ],
      progressDialog: false,
      progressTitle: "اطلاع‌رسانی",
      progressMessage: "",
      showProgress: false,
      loading: false,
      result: [],
      translatedText: "",
      business: "",
      tabs: 0,
      type: "",
      count: 1000,
      helpData: [],
      serviceName: "Qrland",
      componentName: "createqr",
      //new - Advanced Settings Variables
      showAdvancedSettings: false,
      buildingList: [],
      refreshingBuildingList: false,
      organizationName: "",
      latinName: "",
      files: {
        icon: null,
        screenshot: null,
      },
      headerPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "180deg",
        },
      },
      bodyPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
      logoLoading: false,
      screenshotLoading: false,
      colorPalette: {
        headerColor: "#AA7630",
        bodyColor: "#EBCB63",
        textColor: "#000000",
      },
      colorTabs: 0,
      headerColorTabs: 0,
      bodyColorTabs: 0,
      headerGradientColor1: "#AA7630",
      headerGradientColor2: "#EBCB63",
      bodyGradientColor1: "#AA7630",
      bodyGradientColor2: "#EBCB63",
      headerGradientPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
      bodyGradientPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
    };
  },

  async mounted() {
    //new - Initialize building list
    await this.fetchBuildingList();

    // همگام‌سازی colorPalette با cardTexts.pallete
    this.colorPalette = {
      headerColor: this.cardTexts.pallete.headColor,
      bodyColor: this.cardTexts.pallete.bodyColor,
      textColor: this.cardTexts.pallete.textColor,
    };

    this.cardTexts.socialMedia = {
      // address: [
      //   {
      //     label: "آدرس",
      //     text: "لینک سایت مورد نظر را وارد نمایید",
      //     hint: "لینک سایت مورد نظر را وارد نمایید",
      //     pattern: "",
      //     prefix: "URL",
      //     url: "",
      //     img: "/media/socialIcon/40icon/location.svg",
      //     svg: "svgLocation",
      //   },
      //   {
      //     label: "آدرس",
      //     text: "لینک سایت مورد نظر را وارد نمایید",
      //     hint: "لینک سایت مورد نظر را وارد نمایید",
      //     pattern: "",
      //     prefix: "URL",
      //     url: "",
      //     img: "/media/socialIcon/40icon/location.svg",
      //     svg: "svgLocation",
      //   },
      // ],
      // instagram: [
      //   {
      //     label: "اینستاگرام",
      //     text: "نام کاربری خود را وارد نمایید",
      //     hint: "نام کاربری خود را وارد نمایید",
      //     pattern: "",
      //     prefix: "",
      //     url: "",
      //     img: "/media/socialIcon/40icon/instagram.svg",
      //     svg: "svgInstagram",
      //   },
      // ],
      // whatsapp: [
      //   {
      //     label: "واتساپ",
      //     text: "",
      //     hint: "",
      //     pattern: "",
      //     prefix: "mdi-phone",
      //     url: "",
      //     img: "/media/socialIcon/40icon/whatsapp.svg",
      //     svg: "svgWhatsapp",
      //   },
      // ],
    };
    this.qrDesign = {
      width: 300,
      height: 300,
      data: this.info?.link || "https://qr2.in",

      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#933490" },
            { offset: 1, color: "#933490" },
          ],
        },
      },
      backgroundOptions: { color: "#FFFFFFFF" },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#690a70",
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: { type: "", color: "#b00cab" },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    };
    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });
    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });
    await this.fetch(this.tableProps);
  },
  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapGetters("localstorage", ["typeFilter"]),
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  watch: {
    oldDataQr(val) {
      if (val) {
        this.mylastQr = true;
        this.$nextTick(() => {
          // this.$refs.qrselect.focus();
        });
      } else {
        this.mylastQr = false;
      }
    },
    perfix_business: {
      deep: true,
      handler(val) {
        if (!!val) {
          this.business = `${this.perfix_business} ${this.Textbusiness}`;
        }
      },
    },
    Textbusiness: {
      deep: true,
      handler(val) {
        if (!!val) {
          this.business = `${this.perfix_business} ${this.Textbusiness}`;
        }
      },
    },
    "cardTexts.photo.gallery": {
      deep: true,

      handler(val) {
        debounce(() => {
          if (!val) this.cardTexts.photo.gallery = [{ name: "", images: [] }];
          this.$root.$emit("rerenderSwiper");
        }, 400);
      },
    },
    "cardTexts.pallete": {
      deep: true,
      handler(newPalette) {
        this.colorPalette = {
          headerColor: newPalette.headColor,
          bodyColor: newPalette.bodyColor,
          textColor: newPalette.textColor,
        };
      },
    },
  },
  async created() {
    await this.getQrTypes();
    this.domainId = 5;
    await this.fetch();
  },
  methods: {
    updateAddress() {
      this.$api
        .put(`/v1/testQr/identifier/${this.createQrID}`, {
          identifier: this.address,
        })
        .then(({ data }) => {})
        .catch(({ response }) => {});
    },
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (regex.test(str) || without_regex.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    generateUID() {
      return "xxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    openFileDialog() {
      this.$refs.fileInput.$refs.input.click();
    },
    async selectedHandlerUrl() {
      if (!this.url_) {
        this.errorurl = "لطفا آدرس سایت را وارد کنید";
        return;
      }
      this.errorurl = "";
      try {
        const { data } = await RobotAxios.post(
          `/api/enamad/manual?url=${this.url_}&qr_id=11&response=1`,
          {
            token: localStorage.getItem("id_token"),
          },
        );
        if (!!data && !!data.data) {
          const qrData = data.data;
          // map data to cardTexts
          // this.cardTexts.userName = qrData.data.userName || "";
          // this.cardTexts.workField = qrData.data.workField || "";

          this.cardTexts.organizationName =
            this.organizationName.trim() !== ""
              ? this.organizationName.trim()
              : qrData?.title || "";

          this.cardTexts.phoneNumber =
            !!qrData?.phone && !!qrData?.title
              ? [{ number: qrData.phone, text: qrData.title }]
              : [{ number: "", text: "" }];
          this.cardTexts.socialMedia =
            qrData.socialMedia || this.cardTexts.socialMedia || {};

          this.cardTexts.address =
            qrData.address || this.cardTexts.address || "";

          this.cardTexts.city = qrData.city || this.cardTexts.city || "";

          this.cardTexts.province =
            qrData.province || this.cardTexts.province || "";

          this.cardTexts.country =
            qrData.country || this.cardTexts.country || "";

          this.cardTexts.website = qrData.site || this.cardTexts.website || "";
          this.cardTexts.aboutUs =
            qrData.aboutUs ||
            qrData.description ||
            this.cardTexts.aboutUs ||
            "";

          this.cardTexts.blog = qrData.blog || this.cardTexts.blog || [];

          this.cardTexts.email = qrData.email || this.cardTexts.email || "";

          this.cardTexts.fax = qrData.fax || this.cardTexts.fax || "";

          this.cardTexts.location = qrData.location || this.cardTexts.location;

          this.cardTexts.companyNumber =
            qrData.companyNumber ||
            qrData.phone ||
            this.cardTexts.companyNumber;

          this.cardTexts.codePostal =
            qrData.codePostal || this.cardTexts.codePostal;

          this.cardTexts.coordinates =
            qrData.coordinates || this.cardTexts.coordinates;

          this.cardTexts.copyright =
            qrData.copyright || this.cardTexts.copyright;

          this.cardTexts.advanceSettings = !!this.files.screenshot
            ? this.cardTexts.advanceSettings
            : qrData.advanceSettings;

          this.cardtexts.logo = !!this.files.icon
            ? this.cardTexts.logo
            : qrData.logo || "";

          // console.log("cardTexts after url selection", this.cardTexts);
          this.$toast.success("داده‌های QR با موفقیت بارگذاری شد.");
        } else {
          //this.$toast.error("داده‌های QR یافت نشد.");
        }
      } catch (error) {
        //console.error("Error fetching user data:", error);
      } finally {
        this.qrselectloading = false;
      }
    },
    handleSelection() {
      if (this.selectedQr !== null) return;
      const item = this.selectedQr;
      if (item && item.value) {
        this.selectedQr = item;
        this.fetchUserData(item.value); // فراخوانی متد با شناسه QR
      } else {
        // console.log("No item selected");
      }
    },
    async fetchUserData(identifier) {
      try {
        this.qrselectloading = true;
        const { data } = await this.$api.get(`/v1/testQr/find/${identifier}`);
        if (data && data.data && data.data.data) {
          const qrData = data.data.data;
          // map data to cardTexts

          this.cardTexts.userName = qrData.data.userName || "";
          this.cardTexts.workField = qrData.data.workField || "";
          this.cardTexts.organizationName =
            this.organizationName?.trim() ||
            qrData?.data?.organizationName?.trim() ||
            "";
          this.cardTexts.phoneNumber = qrData.data.phoneNumber || [
            { number: "", text: "" },
          ];
          this.cardTexts.socialMedia =
            qrData.data.socialMedia || this.cardTexts.socialMedia || {};
          this.cardTexts.address =
            qrData.data.address || this.cardTexts.address || "";
          this.cardTexts.city = qrData.data.city || this.cardTexts.city || "";
          this.cardTexts.province =
            qrData.data.province || this.cardTexts.province || "";
          this.cardTexts.country =
            qrData.data.country || this.cardTexts.country || "";
          this.cardTexts.website =
            qrData.data.website || this.cardTexts.website || "";
          this.cardTexts.aboutUs =
            qrData.data.aboutUs || this.cardTexts.aboutUs || "";
          this.cardTexts.blog = qrData.data.blog || this.cardTexts.blog || [];
          this.cardTexts.email =
            qrData.data.email || this.cardTexts.email || "";
          this.cardTexts.fax = qrData.data.fax || this.cardTexts.fax || "";
          this.cardTexts.location =
            qrData.data.location || this.cardTexts.location;
          this.cardTexts.companyNumber =
            qrData.data.companyNumber || this.cardTexts.companyNumber;
          this.cardTexts.codePostal =
            qrData.data.codePostal || this.cardTexts.codePostal;
          this.cardTexts.coordinates =
            qrData.data.coordinates || this.cardTexts.coordinates;
          this.cardTexts.copyright =
            qrData.data.copyright || this.cardTexts.copyright;
          this.cardTexts.advanceSettings =
            this.files.screenshot || this.files.icon
              ? this.cardTexts.advanceSettings
              : qrData.data.advanceSettings || this.cardTexts.advanceSettings;

          this.$toast.success("داده‌های QR با موفقیت بارگذاری شد.");
        } else {
          //this.$toast.error("داده‌های QR یافت نشد.");
        }
      } catch (error) {
        //console.error("Error fetching user data:", error);
      } finally {
        this.qrselectloading = false;
      }
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };
      this.fetch(props);

      this.$nextTick(() => {
        this.fetch(props);
        window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
      });
    },
    onPerPage() {
      // this.fetch()
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },

    getOldData() {
      this.loading = true;

      this.$api
        .get(`/v1/testQr/find/${this.selectedlink}`)
        .then(({ data }) => {
          this.info = data.data;
          this.editedName = data.data.visitName;
          this.$nextTick(() => {
            this.getVisits();
            // this.getStatics()
          });
        })
        .finally(() => (this.loading = false));
    },

    countData2() {
      let p = {};

      // set filters
      p.sort = "desc";
      p.search = "";

      // end filters
      this.$api
        .get("/v1/testQr/user/count", {
          params: p,
        })
        .then((data) => {
          this.countData = data.count;
        })
        .finally(() => {});
    },
    async fetch(params = this.tableProps) {
      if (this.loadingdata) return;
      this.loadingdata = true;
      this.qrselectloading = true;
      try {
        await this.countData2();
        params.length = this.countData;
        const { data } = await this.$api.get("/v1/testQr/user", {
          params: params,
        });

        this.pagination = await data.data;
        this.list = await data.data.data;

        // this.QrData = this.list
        //   .filter((x) => x.domain !== null && x.extra_short?.identifier)
        //   .map((x) => ({
        //     value: `${x.domain.name}${x.extra_short.identifier}`,
        //     text: `${x.data.data.visitName} - ${x.domain.name}${x.extra_short.identifier}`,
        //     name: x.data.data.visitName,
        //   }));

        this.$set(this, "QrData", [
          ...this.list
            .filter((x) => x.domain !== null && x.identifier)
            .map((x) => ({
              value: `${x.domain.name}${x.identifier}`,
              text: `${x?.data?.data?.visitName || "بدون نام"} - ${
                x.domain.name
              }${x.identifier}`,
              name: x?.data?.data?.visitName || "بدون نام",
            })),
        ]);
        //this.firstPage = false;
        //this.currentPage = data.data.current_page;
      } catch (error) {
      } finally {
        this.loadingdata = false;
        this.qrselectloading = false;
      }
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    filterEnglishOnly(text) {
      return text.replace(/[^a-zA-Z0-9]/g, "");
    },
    clearFile() {
      this.file = null;
      this.$toast.info("فایل پاک شد.");
    },
    getdomain() {
      this.domainId = 5;
    },
    updateBusiness(businessName) {
      this.perfix_business = businessName;
    },
    autoSave(options) {
      this.qrDesign = options;
    },

    async markQr() {
      try {
        if (this.radioGroup === "flagUrl" && !!this.url_) {
          await this.selectedHandlerUrl();
        }
        if (this.organizationName.trim() !== "")
          this.cardTexts.organizationName = this.organizationName?.trim();
        let obj = {
          type: "VisitCard",
          qrType: "dynamic",
          title: this.cardTexts.visitName,
          domain_id: this.domainId,
          data: JSON.stringify({
            theme: this.theme,
            data: this.cardTexts,
            orders: this.orders,
          }),
          qr: JSON.stringify(this.qrDesign),
          identifier: this.filterEnglishOnly(this.dtUrl),
        };

        const { data } = await this.$api.post("/v1/testQr/store", obj);
        this.createdId = await data.data.identifier;
        // this.createdDomain =  this.destItems.find(
        //   (item) => item.id === this.domainId
        // ).name;

        this.createdDomain = "qrland.in/";
        this.$toast.success("کارت ویزیت شما در حال ساخت است.");
        this.info = await data?.data;
        this.qrDesign = { ...this.info.qr };
        await this.$nextTick();
        if (this.$refs.qrCanvas && !!this.info.link) {
          await this.$refs.qrCanvas.appendCanvas(this.info.link);
        }
        await this.$nextTick();

        await new Promise((resolve, reject) => {
          const checkSvg = () => {
            if (this.qrSvgDataUrl) {
              // console.log("qrSvgDataUrl generated:", this.qrSvgDataUrl);
              resolve();
            } else {
              setTimeout(checkSvg, 10000);
            }
          };
          setTimeout(() => reject(new Error("SVG generation timeout")), 10000);
          checkSvg();
        });

        await this.checkVideo();
        if (!data || this.info === null) {
        } else if (!!data && !!data.data && !!data.data.qrId) {
          this.qrId = this.info.qrId;
          const data2 = new FormData();
          data2.append("type", "VisitCard");
          data2.append("image", this.qrSvgDataUrl);
          data2.append("qrType", "dynamic");
          data2.append("domain", this.createdDomain);
          data2.append("identifier", this.createdId || this.info.identifier);
          data2.append("_method", "PUT");
          // console.log(this.qrDesign, "design");
          data2.append("qr", JSON.stringify(this.qrDesign));
          data2.append("qr_id", this.qrId);
          data2.append(
            "data",
            JSON.stringify({
              theme: this.theme,
              data: this.cardTexts,
              orders: this.orders,
            }),
          );

          await this.$api
            .post("/v1/testQr/update", data2, {
              headers: {
                "Content-Type": "application/from-data",
              },
            })
            .then(({ data }) => {
              this.info = data.data;
              this.$toast.success("کارت ویزیت شما با موفقیت  ساخته شد .");

              // this.goto("qr/list");
            })
            .catch((err) => {})
            .finally(() => {});
        }
      } catch ({ response }) {
        if (response?.data?.errors) {
          if (
            response.data.errors.identifier[0] ===
              "آدرس کیوآر قبلا انتخاب شده است." &&
            response?.status === 422
          ) {
            this.step = 1;
            // console.log(response?.data?.errors);
            const parts = this.filterEnglishOnly(this.dtUrl).split("-");
            const lastPart = parts[parts.length - 1];

            if (!isNaN(lastPart)) {
              parts[parts.length - 1] = this.generateUID(); //splice(DateTime.now(), 6, 4); // Number(lastPart) + 1;

              this.dtUrl = parts.join("-");
            } else {
              this.dtUrl = parts.join("-");
              this.dtUrl = `${this.filterEnglishOnly(
                this.dtUrl,
              )}-${this.generateUID()}`;
              await this.markQr();
            }
          } else {
            Object.keys(response.data.errors).forEach((item) => {
              this.$toast.error(response.data.errors[item][0], {
                timeout: 3000,
              });
            });
          }
        } else {
          // this.$toast.error("ساخت کیوآر با خطا روبرو شد!");
        }
      } finally {
        this.loading = false;
        // this.isMarkQrRunning = false;
      }
    },
    selectQr(data) {
      this.type = data;
    },

    async onFileChange(file) {
      if (file === null) {
        this.file = null;
        // console.log("فایل پاک شد");
        return;
      }
      if (
        file instanceof File &&
        ["image/jpeg", "image/png"].includes(file.type)
      ) {
        this.file = file;
        // console.log("فایل انتخاب شده:", file);
        await this.getInfo();
      } else {
        console.error("نوع فایل مشکل دارد:", file);
        this.$toast.error("لطفاً فقط فایل‌های JPG یا PNG انتخاب کنید.");
        this.file = null;
      }
    },
    async getInfo() {
      if (!this.file) {
        this.$modal.error("لطفاً یک تصویر فروشگاه/ محصول انتخاب کنید.");
        return;
      }
      try {
        const fileUrl = await saveOnCdnFiles(
          this.file,
          `upload_${Date.now()}`,
          "uploads",
        );
        this.$toast.success("تصویر با موفقیت آپلود شد: ");
      } catch (error) {
        this.$toast.error("خطا در آپلود تصویر!");
        console.error(error);
      }
    },
    cleanBusinessName(business) {
      const words = business
        .split(" ")
        .filter((word, index, arr) => arr.indexOf(word) === index);
      return words.join(" ").trim();
    },
    // tryprocess(Id) {
    //   // call api for failed process
    //   //https://ai-api.terminalads.com/api/process/tryAgain/${qr_id}
    //   axios
    //     .get(`https://ai-api.terminalads.com/api/process/tryAgain/${Id}`, {
    //       headers: this.header(),
    //     })
    //     .then((response) => {
    //       this.$toast.success("فرآیند با موفقیت تکرار شد.");
    //     })
    //     .catch((error) => {
    //       console.error("Error retrying process:", error);
    //       this.$toast.error("خطا در تکرار فرآیند!");
    //     });
    // },
    // checkProcess(id) {
    //   //https://ai-api.terminalads.com/api/process/check/${id}
    //   axios
    //     .get(`https://ai-api.terminalads.com/api/process/check/${id}`, {
    //       headers: this.header(),
    //     })
    //     .then((response) => {
    //       //response.id
    //       //response.status
    //       //response.error
    //       //response.end_at
    //       //response.payload.payload.data.images
    //       //response.payload.payload.data.title_en
    //       //response.payload.payload.step //for step check
    //       //response.payload.payload.max_step //for check
    //       //response.payload.payload.imagesProcessType
    //       if (response.status === "success") {
    //         //process //failed
    //       } else if (response.status === "failed") {
    //         //call
    //         this.tryprocess(id);
    //       } else if (response.status === "process") {
    //         let val_process =
    //           (response.payload.payload.step /
    //             response.payload.payload.max_step) *
    //           100;
    //         //set progress bar
    //       }

    //       this.$toast.success("فرآیند با موفقیت تکرار شد.");
    //     })
    //     .catch((error) => {
    //       console.error("Error retrying process:", error);
    //       this.$toast.error("خطا در تکرار فرآیند!");
    //     });
    // },
    sendData() {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        if (this.files.screenshot !== null) {
          formData.append("image", this.files.screenshot);
        }
        if (!!this.files.icon) formData.append("logo", 1);
        formData.append("type", "qrAutoImage");
        formData.append("title", this.perfix_business);
        formData.append("product_name", this.Textbusiness);
        formData.append("processType", "visitcard");
        formData.append("url", this.url_);
        if (this.organizationName !== "")
          formData.append("organizationName", this.organizationName);

        axios
          .post(this.$aiApi + "/process", formData, {
            headers: this.header(),
          })
          .then((data) => {
            this.auto_id = data.data.id;
            this.auto_build = "process";
            this.cardTexts.auto_id = this.auto_id;
            this.cardTexts.auto_build = this.auto_build;

            resolve(data);
          })
          .catch((error) => {
            this.$modal.info(
              "هشدار",
              error.response.status === 422
                ? "خطا در ارسال اطلاعات! لطفا با پشتیبانی تماس بگیرید. پس از رفع مشکل دوباره تلاش کنید."
                : "شما یک کیوآر در حال ساخت دارید. پس از تکمیل ساخت کیوآر در لیست کیوآر من برای ساخت کیوآر جدید مراجعه کنید.",
            );
            this.completeProcess = false;
            reject(error);
          })
          .finally(() => {});
      });
    },
    async generatorTextAi() {
      if (this.loading) return;

      this.progressTitle = "اطلاع‌رسانی";
      this.progressMessage = `سامانه در حال ساخت کیوآر کد شماست.\nزمان تقریبی ساخت 1 الی 3 دقیقه خواهد بود.`;
      this.showProgress = true;
      this.progressDialog = true;

      this.loading = true;
      try {
        await this.sendData(); // send data for back
        if (this.completeProcess === true) {
          this.business = `${this.perfix_business} ${this.Textbusiness}`;
          await this.translatePrompt(this.business);
          const englishBusiness = this.translatedText;
          // const cleanedBusiness = this.cleanBusinessName(englishBusiness);
          this.cardTexts.visitName = this.business;
          this.dtUrl =
            this.latinName.toLowerCase().replace(/\s+/g, "-") ||
            englishBusiness.toLowerCase().replace(/\s+/g, "-");

          // const descriptionPrompt = this.file
          //   ? `Analyze the provided image and generate a professional description for a business card for a ${cleanedBusiness}. Include:
          //     - A short title (1-2 words) in a <h1> tag.
          //     - A comprehensive description (minimum 20 sentences, at least 250 words) of the business inspired by the image in a <p> tag, detailing its mission, vision, core values, industry context, target audience, unique value proposition, operational approach, and competitive advantages with a specialized and technical focus.
          //     - 3-6 key features or services offered, each in a <li> tag within a <ul> tag. Each <li> must include a <strong> tag for the feature title (1-3 words) followed by a colon and a detailed, specialized description (1 sentence) highlighting technical expertise, industry-specific methodologies, or unique service aspects.
          //     Use a professional, modern, and industry-specific tone, suitable for a digital business card, emphasizing technical proficiency and specialized knowledge. Return only the structured HTML with <h1>, <p>, and <ul><li> tags. Do not use additional tags like <div>. Ensure each <li> contains a <strong> tag for the feature title followed by a colon and a plain text description with detailed, technical, and business-relevant content.`
          //   : `Generate a professional description for a business card for a ${cleanedBusiness}. Include:
          //     - A short title (1-2 words) in a <h1> tag.
          //     - A comprehensive description (minimum 20 sentences, at least 250 words) of the business in a <p> tag, detailing its mission, vision, core values, industry context, target audience, unique value proposition, operational approach, and competitive advantages with a specialized and technical focus.
          //     - 3-6 key features or services offered, each in a <li> tag within a <ul> tag. Each <li> must include a <strong> tag for the feature title (1-3 words) followed by a colon and a detailed, specialized description (1 sentence) highlighting technical expertise, industry-specific methodologies, or unique service aspects.
          //     Use a professional, modern, and industry-specific tone, suitable for a digital business card, emphasizing technical proficiency and specialized knowledge. Return only the structured HTML with <h1>, <p>, and <ul><li> tags. Do not use additional tags like <div>. Ensure each <li> contains a <strong> tag for the feature title followed by a colon and a plain text description with detailed, technical, and business-relevant content.`;          //       file: this.file || null,
          //       description: descriptionPrompt,
          //     });
          //    const aiText = data.data?.html || "";
          // await this.translatePromptChat(aiText);
          // await this.processAiText(this.Ai_Text, englishBusiness);
          // await this.genenterimageAi(englishBusiness);

          await this.markQr();
        }
        //   this.goto("qr/list");
        await this.qrUpdate(true);
        this.refreshBuildingList(); //fetch data for list of building
        this.loading = false;
        this.$refs.progressModal.complete();
      } catch (error) {
        // this.$toast.error("خطا در دریافت اطلاعات!");
        console.error(error);
        this.$refs.progressModal.complete();
        // this.$refs.progressModal.close();
      } finally {
        this.loading = false;
        //    this.goto("qr/list");
      }
    },
    cleanHtmlText(htmlText, preserveNewlines = false) {
      if (typeof htmlText !== "string") {
        return "";
      }
      if (!/<[^>]+>/.test(htmlText)) {
        const text = htmlText.trim();
        return preserveNewlines ? text : text.replace(/\s+/g, " ");
      }
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          htmlText || "<div></div>",
          "text/html",
        );
        const text = doc.body.textContent || "";
        return preserveNewlines
          ? text.trim()
          : text.trim().replace(/\s+/g, " ");
      } catch (error) {
        console.error("Error parsing HTML text:", error.message);
        return "";
      }
    },
    async processAiText(aiHtml, englishBusiness, englishHtml = null) {
      // Parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(aiHtml || "<div></div>", "text/html");
      // Extract title (first heading or fallback)
      const titleElement = doc.querySelector("h1, h2, h3") || {
        textContent: englishBusiness,
      };
      const englishDoc = englishHtml
        ? parser.parseFromString(englishHtml, "text/html")
        : null;
      const persianTitle =
        // this.cleanHtmlText(titleElement.textContent) ||
        englishBusiness || "کارت ویزیت";

      // Extract description (first paragraph, div, or fallback)
      const descriptionElement = doc.querySelector("p, div") || {
        textContent: "",
      };
      const persianDescription =
        this.cleanHtmlText(descriptionElement.textContent) ||
        "توضیحات ارائه خدمات حرفه‌ای برای کسب‌وکار شما.";

      // Extract features (list items or fallback)
      const listItems = Array.from(
        doc.querySelectorAll("li, p > span, div > span"),
      );
      const items = listItems
        // .slice(0, 5)
        .map((li) => {
          // Limit to 5 features
          const strong = li.querySelector("strong, b");
          const englishLi = englishDoc?.querySelectorAll(
            "li, p > span, div > span",
          )[index];
          const englishStrong = englishLi?.querySelector("strong, b");
          return {
            title:
              strong?.textContent.trim() ||
              li.textContent.trim().split(":")[0] ||
              "",
            description: strong
              ? this.cleanHtmlText(
                  li.textContent.replace(strong.textContent, ""),
                )
              : this.cleanHtmlText(
                  li.textContent.split(":").slice(1).join(":"),
                ) || li.textContent.trim(),
            original:
              englishStrong?.textContent.trim() ||
              englishLi?.textContent.trim().split(":")[0] ||
              li.textContent.trim(),
          };
        })
        .filter((item) => item.title || item.description); // Remove empty items

      // Translate items to Persian
      const persianItems = await Promise.all(
        items.map(async (item) => ({
          title: item?.title || "ویژگی",
          description: item.description || "توضیحات",
          original: item.title || item.description,
        })),
      );
      if (persianItems.length === 0) {
        try {
          const fallbackTitle = "ویژگی";
          const fallbackDescription = "توضیحات";
          persianItems.push({
            title: fallbackTitle,
            description: fallbackDescription,
            original: "Feature",
          });
        } catch (error) {
          console.error("Fallback feature translation error:", error.message);
          persianItems.push({
            title: "ویژگی",
            description: "توضیحات",
            original: "Feature",
          });
        }
      }
      // Assign icons based on English text
      const icons = await this.assignIcons(
        items.map((item) => item.original || item.title || item.description),
      );

      // Update cardTexts
      this.cardTexts.visitName = this.business || persianTitle;
      this.cardTexts.aboutUs = this.cleanHtmlText(persianDescription)
        .toLowerCase()
        .replace("html", "")
        .replace("` `", "")
        .replace("HTML", "")
        .replace("`", "");
      this.cardTexts.extraFields = persianItems.map((item, index) => ({
        icon: icons[index] || "mdi-information",
        name: item.title,
        value: item.description,
      }));

      // Set dtUrl for QR code
      this.dtUrl =
        this.latinName.toLowerCase().replace(/\s+/g, "-") ||
        englishBusiness.toLowerCase().replace(/\s+/g, "-");
    },
    // async processAiText(aiHtml, englishBusiness) {
    //   // Parse HTML
    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(aiHtml || "<div></div>", "text/html");
    //   // Extract title (first heading or fallback)
    //   const titleElement = doc.querySelector("h1, h2, h3") || {
    //     textContent: englishBusiness,
    //   };
    //   let title = this.cleanHtmlText(titleElement.textContent);
    //   if (!title) title = englishBusiness;
    //   const persianTitle =
    //     (await this.translatePrompt(title, "en", "fa")) || "کارت ویزیت";

    //   // Extract description (first paragraph, div, or fallback)
    //   const descriptionElement = doc.querySelector("p, div") || {
    //     textContent: "",
    //   };
    //   let description = this.cleanHtmlText(descriptionElement.textContent);
    //   const persianDescription = description
    //     ? await this.translatePrompt(description, "en", "fa")
    //     : "توضیحات ارائه خدمات حرفه‌ای برای کسب‌وکار شما.";

    //   // Extract features (list items or fallback)
    //   const listItems = Array.from(
    //     doc.querySelectorAll("li, p > span, div > span")
    //   );
    //   const items = listItems
    //     .slice(0, 5)
    //     .map((li) => {
    //       // Limit to 5 features
    //       const strong = li.querySelector("strong, b");
    //       return {
    //         title:
    //           strong?.textContent.trim() ||
    //           li.textContent.trim().split(":")[0] ||
    //           "",
    //         description: strong
    //           ? this.cleanHtmlText(
    //               li.textContent.replace(strong.textContent, "")
    //             )
    //           : this.cleanHtmlText(
    //               li.textContent.split(":").slice(1).join(":")
    //             ) || li.textContent.trim(),
    //       };
    //     })
    //     .filter((item) => item.title || item.description); // Remove empty items

    //   // Translate items to Persian
    //   const persianItems = await Promise.all(
    //     items.map(async (item) => ({
    //       title: item.title
    //         ? await this.translatePrompt(item.title, "en", "fa")
    //         : "ویژگی",
    //       description: item.description
    //         ? await this.translatePrompt(item.description, "en", "fa")
    //         : "توضیحات",
    //       original: item.title || item.description,
    //     }))
    //   );

    //   // Assign icons based on English text
    //   const icons = await this.assignIcons(
    //     items.map((item) => item.title || item.description)
    //   );

    //   // Update cardTexts
    //   this.cardTexts.visitName = this.business || persianTitle;
    //   this.cardTexts.aboutUs = this.cleanHtmlText(persianDescription)
    //     .toLowerCase()
    //     .replace("html", "")
    //     .replace("` `", "")
    //     .replace("HTML", "")
    //     .replace("`", "");
    //   this.cardTexts.extraFields = persianItems.map((item, index) => ({
    //     icon: icons[index] || "mdi-information",
    //     name: item.title,
    //     value: item.description,
    //   }));

    //   // Set dtUrl for QR code
    //   this.dtUrl = englishBusiness.toLowerCase().replace(/\s+/g, "-");
    // },

    formatText(text) {
      return text
        .replace(/\s+/g, " ")
        .replace(/(\.|\!|\?)\s*/g, "$1\n")
        .trim();
    },
    async assignIcons(texts) {
      const iconMap = {
        "scan|scanning|barcode|qr|read|reader|code|qrcode": "mdi-qrcode-scan",
        "precision|accuracy|target|exact|correct|pinpoint|sharp": "mdi-target",
        "durable|durability|resilient|strong|robust|tough|sturdy|hardy":
          "mdi-shield-check",
        "response|speed|fast|quick|rapid|swift|efficient|prompt":
          "mdi-clock-fast",
        "user-friendly|ease|simple|usable|intuitive|easy|accessible|straightforward":
          "mdi-account-check",
        "security|secure|safe|safety|protected|trustworthy|reliable|encrypted":
          "mdi-lock",
        "quality|high-quality|premium|superior|excellent|top-notch|exceptional":
          "mdi-star",
        "innovation|innovative|modern|advanced|cutting-edge|new|forward-thinking":
          "mdi-lightbulb-on",
        "connectivity|connection|network|wireless|bluetooth|internet|linked":
          "mdi-wifi",
        "compatibility|compatible|versatile|flexible|adaptable|universal":
          "mdi-cellphone-link",
        "portable|portability|mobile|lightweight|compact|travel-friendly":
          "mdi-briefcase",
        "battery|power|energy|long-lasting|charge|rechargeable|endurance":
          "mdi-battery",
        "design|style|stylish|elegant|aesthetic|beautiful|sleek|modern":
          "mdi-palette",
        "dimensions|size|compact|large|small|measurement|proportion":
          "mdi-ruler",
        "weight|light|heavy|lightweight|featherweight": "mdi-weight",
        "color|colour|vivid|bright|shade|hue|vibrant": "mdi-format-color-fill",
        "eco-friendly|environment|green|sustainable|recyclable|biodegradable":
          "mdi-leaf",
        "support|customer-service|assistance|help|care|aftercare|service":
          "mdi-headset",
        "versatile|multifunctional|all-in-one|multi-purpose|multi-use":
          "mdi-all-inclusive",
        "technology|tech|digital|smart|intelligent|automated": "mdi-chip",
        "global|worldwide|international|universal|cross-border": "mdi-earth",
        "affordable|cost-effective|budget-friendly|cheap|value|economical":
          "mdi-currency-usd",
        "performance|performant|powerful|strong|effective|high-performance":
          "mdi-gauge",
        "privacy|private|confidential|discreet|secure-data": "mdi-eye-off",
        "installation|setup|easy-to-install|assembly|deploy": "mdi-tools",
        "warranty|guarantee|assurance|certified|backed": "mdi-certificate",
        "accessibility|available|reach|convenient|handy": "mdi-map-marker",
        "stability|stable|dependable|consistent|steady": "mdi-anchor",
        "collaboration|teamwork|partnership|cooperation|synergy":
          "mdi-account-group",
        "information|informative|details|data|insights|knowledge":
          "mdi-information",
        "customization|customizable|personalized|tailored|bespoke": "mdi-cog",
        "scalability|scalable|expandable|grow|growth": "mdi-arrow-expand",
        "reliability|reliable|trusty|dependable|consistent": "mdi-check-circle",
        "automation|automated|self-operating|smart-operation": "mdi-robot",
        "comfort|comfortable|ergonomic|cozy|user-comfort": "mdi-sofa",
        "efficiency|efficient|optimized|streamlined|productive": "mdi-rocket",
        "weather-resistant|waterproof|dustproof|rugged":
          "mdi-weather-partly-cloudy",
        "real-time|live|instant|immediate": "mdi-update",
        "integration|integrated|seamless|connect|unified": "mdi-puzzle",
        "health|wellness|medical|care|hygiene": "mdi-hospital",
        "food|cuisine|menu|dining|culinary": "mdi-food",
        "education|learning|training|knowledge|study": "mdi-school",
        "entertainment|fun|media|leisure|enjoyment": "mdi-television",
      };
      return texts.map((text) => {
        const lowerText = text.toLowerCase();
        for (const [pattern, icon] of Object.entries(iconMap)) {
          const regex = new RegExp(`\\b(${pattern})\\b`, "i");
          if (regex.test(lowerText)) {
            return icon;
          }
        }
        return "mdi-information";
      });
    },
    async genenterimageAi(englishBusiness) {
      try {
        // Handle custom logo first
        const customLogoUploaded = await this.handleCustomLogo();

        const cleanBusinessName = (business) => {
          const words = business
            .split(" ")
            .filter((word, index, arr) => arr.indexOf(word) === index);
          return words.join(" ").trim();
        };
        const cleanedBusiness = cleanBusinessName(englishBusiness);

        // Only generate logo if no custom logo was uploaded
        const logoPrompt = customLogoUploaded
          ? null
          : `A minimalist, text-free logo icon that exclusively represents the specific ${cleanedBusiness}, featuring a modern, clean design with high contrast and vibrant colors. The icon must precisely capture the unique essence, core values, and primary activities of the ${cleanedBusiness}, using imagery that is unmistakably tied to its industry and identity, avoiding any unrelated, generic, or ambiguous elements. Suitable for professional branding, with no text, letters, or language-specific elements included, ensuring high-resolution quality.`;

        const bannerPrompt = `A wide, text-free promotional banner that vividly and exclusively depicts the core activities and identity of the specific ${cleanedBusiness}, with a vibrant, dynamic composition in a professional and modern style. The imagery must be highly specific to the ${cleanedBusiness}, using elements that directly reflect its industry, services, or products, avoiding any unrelated, generic, or irrelevant visuals, and designed in high resolution for website headers, with no text, letters, or language-specific elements included.`;

        const mainImagePrompt = `A high-resolution, text-free main image that prominently and exclusively showcases the core elements and identity of the specific ${cleanedBusiness}, in a realistic and professional style with warm lighting. The image must be precisely tailored to the ${cleanedBusiness}, using visuals that directly reflect its industry, services, or products, avoiding any unrelated, generic, or irrelevant imagery, and is ideal for website backgrounds, with no text, letters, or language-specific elements included.`;

        // Only include logo generation if no custom logo
        const imageRequests = [];
        if (!customLogoUploaded) {
          imageRequests.push({
            width: 512,
            height: 512,
            text: logoPrompt,
            amount: 1,
          }); // Logo
        }
        imageRequests.push(
          { width: 1024, height: 768, text: bannerPrompt, amount: 1 }, // Banner 1
          { width: 1024, height: 768, text: bannerPrompt, amount: 1 }, // Banner 2
          { width: 1024, height: 768, text: bannerPrompt, amount: 1 }, // Banner 3
          { width: 1024, height: 768, text: bannerPrompt, amount: 1 }, // Banner 4
          { width: 1024, height: 768, text: mainImagePrompt, amount: 1 }, // Main image
        );

        const maxRetries = 4;
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        const generateImage = async (
          { text, width, height, amount },
          retries = maxRetries,
        ) => {
          try {
            const { data } = await axios.post(
              this.$aiApi + "/image/generate/image",
              {
                width: Number(width),
                height: Number(height),
                prompt: text,
                amount: Number(amount),
                type: "inference.flux.schnell.txt2img.v1",
              },
              { headers: this.header() },
            );
            await delay(10000);
            return data?.data[0]?.link || "";
          } catch (error) {
            if (error.response?.status === 403) {
              retries = 0;
              this.$toast.error(
                "ُساخت با خطا مواجه شد لطفا ابتدا پکیج خریداری کنید و مجدد تلاش کنید",
              );
              return null;
            }
            if (retries === 0) {
              return null;
            }
            console.warn(
              `Retrying for prompt: ${text}. Attempts left: ${retries}`,
            );
            await delay(10000); // Wait 10 second before retrying
            return generateImage({ text, width, height, amount }, retries - 1);
          }
        };
        const images = [];
        for (const request of imageRequests) {
          const image = await generateImage(request);
          images.push(image);
        }

        // const images = await Promise.all(
        //   imageRequests.map(async (request) => {
        //     return await generateImage(request);
        //   })
        // );

        // images = await this.saveImages(images);
        if (customLogoUploaded) {
          // No logo was generated, so we have 5 images: 4 banners + 1 main image
          const [banner1, banner2, banner3, banner4, mainImage] = images;
          this.cardTexts.photo.headBackground = mainImage;
        } else {
          // Logo was generated, so we have 6 images: 1 logo + 4 banners + 1 main image
          const [logo, banner1, banner2, banner3, banner4, mainImage] = images;
          this.cardTexts.photo.profile = logo;
          this.cardTexts.photo.headBackground = mainImage;
        }
        // this.cardTexts.photo.gallery = [
        //   {
        //     name: "گالری تصاویر",
        //     images: [banner1, banner2, banner3, banner4],
        //   },
        // ];
        this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
          { name: "گالری تصاویر", images: [] },
        ];
        this.cardTexts.photo.gallery[0].images = [
          ...(this.cardTexts.photo.gallery[0].images || []),
          // {
          //   url: mainImage,
          //   title: "",
          //   name: "",
          //   id: 100011,
          //   description: "",
          //   link: "",
          // },
          // {
          //   url: background,
          //   title: "",
          //   name: "",
          //   id: 100012,
          //   description: "",
          //   link: "",
          // },
          {
            url: banner1,
            title: "",
            name: "banner1",
            id: 10001,
            description: "",
            link: "",
          },
          {
            url: banner2,
            title: "",
            name: "banner2",
            id: 10002,
            description: "",
            link: "",
          },
          {
            url: banner3,
            title: "",
            name: "banner3",
            id: 10003,
            description: "",
            link: "",
          },
          {
            url: banner4,
            title: "",
            name: "banner4",
            id: 10004,
            description: "",
            link: "",
          },
        ];
        this.$root.$emit("rerenderSwiper");
      } catch (error) {
        this.$toast.error("خطا در تولید تصاویر!");
        console.error(error);
      }
    },
    async saveImages(images) {
      const [logo, banner1, banner2, banner3, banner4, mainImage] = images;
      const urlToBlob = async (url) => {
        try {
          const response = await fetch(url);
          if (!response.ok)
            throw new Error(`Failed to fetch image from ${url}`);
          return await response.blob();
        } catch (error) {
          console.error(`Error downloading image from ${url}:`, error);
          return null;
        }
      };
      if (logo) {
        const logoBlob = await urlToBlob(logo);
        if (logoBlob) {
          const logoUrl = await saveOnCdnFiles(
            logoBlob,
            `logo_${this.dtUrl}`,
            "uploads",
          );
          this.cardTexts.photo.profile = logoUrl;
        }
      }

      const bannerUrls = await Promise.all(
        [banner1, banner2, banner3, banner4].map(async (banner, index) => {
          if (banner.image) {
            const bannerBlob = await urlToBlob(banner);
            if (bannerBlob) {
              return await saveOnCdnFiles(
                bannerBlob,
                `banner_${this.dtUrl}_${index + 1}`,
                "uploads",
              );
            }
          }
          return null;
        }),
      );
      if (mainImage) {
        const mainBlob = await urlToBlob(mainImage);
        if (mainBlob) {
          const mainUrl = await saveOnCdnFiles(
            mainBlob,
            `main_${this.dtUrl}`,
            "uploads",
          );
          this.cardTexts.photo.headBackground = mainUrl;
        }
      }

      this.cardTexts.photo.gallery = [
        {
          name: "گالری تصاویر",
          images: bannerUrls.filter((url) => url),
        },
      ];

      this.$root.$emit("rerenderSwiper");
    },
    async getImage(text, width, height, amount) {
      try {
        const { data } = await axios.post(
          this.$aiApi + "/image/generate/image",
          {
            width: Number(width),
            height: Number(height),
            prompt: text,
            amount: Number(amount),
          },
          { headers: this.header() },
        );

        if (!!data.data[0].link) {
          this.result.push({
            image: data.data[0].link,
            prompt: text,
            checked: false,
          });
          this.indexAt = 0;
        }
      } catch (response) {
        console.error(response);
      } finally {
        this.loading = false;
      }
    },
    async getImages(i) {
      this.loading = true;

      let params = {
        paginate: 1,
        page: 1,
        category: undefined,
        dir: "desc",
      };
      const res = await rbAxios
        .get(`${this.$robotApi}/files`, { params })
        .then(({ data }) => {
          let lastImg = this.img?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.img = temp;

          if (!!this.defaultCatName) this.categoryName = this.defaultCatName;

          this.isLastPage = !data.data.items.next_page_url;
          this.page++;
        })
        .catch(({ response }) => {
          console.log("error in get images: ", response);
        })
        .finally(() => (this.loading = false));
    },
    saveImage(result) {
      // Example Base64 string and mimeType
      const base64String = result;
      const mimeType = "application/octet-stream"; // Adjust the MIME type as needed

      // Convert Base64 to Blob
      const fileBlob = base64ToBlob(base64String, mimeType);
      saveOnCdnFiles(
        fileBlob,
        this.result.at(this.indexAt).prompt.replace(/ /g, "_"),
        this.categoryName,
      )
        .then((response) => {
          this.$emit("saved", this.categoryName);
        })
        .catch((error) => {
          // this.$toast.error("خطای آپلود تصویر!");
        })
        .finally(() => {
          console.log(this.result, "result");
        });
    },
    async translatePromptChat(text, to = "fa") {
      if (!text || text.replace(/\n/g, " ").trim() === "") {
        throw new Error("Input text is empty or invalid");
      }
      const prompt = `
Translate the text content of the following HTML to ${to}, preserving all HTML tags and structure exactly as they are. Only translate the text between tags, and do not add any extra text or explanations. Return only the translated HTML.

${text}
`;
      try {
        const { data } = await this.$api.post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: prompt,
        });
        const translatedText = data?.choices?.[0]?.message?.content;
        if (!translatedText) {
          throw new Error("Invalid response from translation API");
        }
        this.Ai_Text = translatedText;
        return translatedText;
      } catch (error) {
        this.$modal.error(
          "خطا",
          "ترجمه متن با مشکل مواجه شد. لطفاً مجدد تلاش کنید.",
        );
        console.error("Translation error:", error.message);
        // throw error;
      }
    },
    //https://qr-api.terminalads.com/api/v1/testQr/user/auto
    ListAuto() {},
    async translatePrompt(
      text,
      from = "fa",
      to = "en",
      maxRetries = 3,
      interval = 10000,
    ) {
      if (!text || text.replace(/\n/g, " ").trim() === "") {
        throw new Error("Input text is empty or invalid");
      }

      let retries = 0;

      while (retries < maxRetries) {
        try {
          const response = await axios.post(
            this.$aiApi + "/image/translate",
            {
              text: text.replace(/\n/g, " "),
              from,
              to,
            },
            { headers: this.header() },
          );
          const translatedText = Array.isArray(response?.data.data)
            ? response?.data?.data?.[0]?.["destination-text"]
            : response?.data?.data?.["destination-text"];

          if (!!translatedText) {
            this.translatedText = translatedText;
            return this.translatedText;
          }
          await new Promise((resolve) => setTimeout(resolve, interval));
          retries++;
        } catch (error) {
          console.error("Translation attempt failed:", error.message);
          if (retries >= maxRetries - 1) {
            throw new Error("Translation failed after maximum retries");
          }
          await new Promise((resolve) => setTimeout(resolve, interval));
          retries++;
        }
      }
      // throw new Error("Translation failed after maximum retries");
    },
    spellCheckerEn(input) {
      const reg = /^[a-zA-Z0-9\s,\-]*$/;
      return input && input.trim().length > 0 && reg.test(input.trim());
    },
    spellChecker(input) {
      const reg = /^[\u0600-\u06FF\u06F0-\u06F9\s,\-]*$/;
      return input && Array.from(input.trim()).every((char) => reg.test(char));
    },
    async qrUpdate(final = false) {
      this.loading = true;
      try {
        this.qrDesign = { ...this.info.qr };
        await this.$nextTick();
        if (this.$refs.qrCanvas && !!this.info.link) {
          await this.$refs.qrCanvas.appendCanvas(this.info.link);
        }
        await this.$nextTick();
        setTimeout(() => {}, 100000);
        await new Promise((resolve, reject) => {
          const checkSvg = () => {
            if (this.qrSvgDataUrl) {
              resolve();
            } else {
              setTimeout(checkSvg, 8000);
            }
          };
          setTimeout(() => reject(new Error("SVG generation timeout")), 8000);
          checkSvg();
        });
        this.checkVideo();
        const data = new FormData();
        data.append("type", "VisitCard");
        data.append("image", this.qrSvgDataUrl);
        data.append("qrType", "dynamic");
        data.append("domain", this.createdDomain);
        data.append("identifier", this.createdId || "");
        data.append("_method", "PUT");
        data.append("qr", JSON.stringify(this.qrDesign));
        data.append(
          "data",
          JSON.stringify({
            theme: this.theme,
            data: this.cardTexts,
            orders: this.orders,
          }),
        );
        const { data: response } = await this.$api.post(
          "/v1/testQr/update",
          data,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        this.info = response.data;
        this.$toast.success("کیوآر کارت ویزیت شما باموفقیت ویرایش شد.");

        if (final) {
          // this.$router.push({ name: "qr/list" });
        }
      } catch (error) {
        // this.$toast.error("خطا در به‌روزرسانی کیوآر!");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    refreshBuildingList() {
      this.refreshingBuildingList = true;
      this.fetchBuildingList()
        .then(() => {
          this.refreshingBuildingList = false;
          this.$toast.success("لیست ساخت‌ها با موفقیت به‌روزرسانی شد.");
        })
        .catch((error) => {
          this.refreshingBuildingList = false;
          this.$toast.error("خطا در به‌روزرسانی لیست ساخت‌ها:", error.message);
        });
    },
    getStatusColor(status) {
      switch (status) {
        case "process":
          return "primary";
        case "success":
          return "success";
        case "failed":
          return "error";
        default:
          return "info";
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "process":
          return "mdi-progress-clock";
        case "success":
          return "mdi-check-circle";
        case "failed":
          return "mdi-close-circle";
        default:
          return "mdi-help-circle";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "process":
          return "در حال ساخت";
        case "success":
          return "ساخت شده";
        case "failed":
          return "ساخت ناموفق";
        default:
          return "در حال ساخت";
      }
    },
    async checkAndFixDuplicateUrl() {
      let baseUrl = this.dtUrl;
      let counter = 1;
      let isDuplicate = true;

      while (isDuplicate && counter <= 9999) {
        try {
          // Check if URL exists
          const response = await this.$api.get(
            `/v1/testQr/check-identifier/${this.dtUrl}`,
          );
          if (response.data.exists) {
            // URL exists, add 4-digit number
            // this.dtUrl = `${baseUrl}-${counter.toString().padStart(4, "0")}`;
            this.dtUrl = `${baseUrl}-${this.generateUID()}`;

            counter++;
          } else {
            isDuplicate = false;
          }
        } catch (error) {
          // If error, assume URL doesn't exist
          isDuplicate = false;
        }
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success("کد رنگ کپی شد");
        })
        .catch(() => {
          this.$toast.error("خطا در کپی کردن");
        });
    },
    updateColorPalette(newPalette) {
      this.colorPalette = newPalette;
      this.cardTexts.pallete.headColor = newPalette.headerColor;
      this.cardTexts.pallete.bodyColor = newPalette.bodyColor;
      this.cardTexts.pallete.textColor = newPalette.textColor;
    },
    //new - Building List Methods
    async fetchBuildingList() {
      try {
        let type = "VisitCard";
        const response = await this.$api.get(
          `/v1/testQr/user/auto?type=${type}`,
        );

        this.buildingList = response.data.data.data || [];
      } catch (error) {
        console.error("Error fetching building list:", error);
        // Add fake data for testing
        // this.buildingList = [
        //   {
        //     id: 1,
        //     title: "کارت ویزیت لوازم خانگی",
        //     status: "process",
        //     progress: 65,
        //     qrType: "کارت ویزیت",
        //     url: "qr2.in/home-appliances",
        //     createdAt: new Date().toISOString(),
        //   },
        //   {
        //     id: 2,
        //     title: "کارت ویزیت رستوران",
        //     status: "success",
        //     progress: 100,
        //     qrType: "کارت ویزیت",
        //     url: "qr2.in/restaurant",
        //     createdAt: new Date(Date.now() - 3600000).toISOString(),
        //   },
        //   {
        //     id: 3,
        //     title: "کارت ویزیت آرایشگاه",
        //     status: "error",
        //     progress: 0,
        //     qrType: "کارت ویزیت",
        //     url: "qr2.in/beauty-salon",
        //     createdAt: new Date(Date.now() - 7200000).toISOString(),
        //   },
        // ];
      }
    },
    async refreshBuildingList() {
      this.refreshingBuildingList = true;
      try {
        await this.fetchBuildingList();
      } finally {
        this.refreshingBuildingList = false;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "process":
          // change color
          return "orange";
        case "success":
          return "green";
        case "error":
          return "red";
        default:
          return "grey";
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "process":
          return "mdi-clock-outline";
        case "success":
          return "mdi-check-circle";
        case "error":
          return "mdi-alert-circle";
        default:
          return "mdi-help-circle";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "process":
          return "در حال ساخت";
        case "success":
          return "تکمیل شده";
        case "error":
          return "خطا در ساخت";
        default:
          return "نامشخص";
      }
    },
    getProgressColor(progress) {
      if (progress < 30) return "red";
      if (progress < 70) return "orange";
      return "green";
    },
    //new - Advanced Settings Methods
    updateHeaderColor(color) {
      if (color) {
        this.headerColor = color;
        this.cardTexts.pallete.headColor = color;
      }
    },
    updateBodyColor(color) {
      if (color) {
        this.bodyColor = color;
        this.cardTexts.pallete.bodyColor = color;
      }
    },
    updateHeaderGradientColor1(color) {
      if (color) {
        this.headerGradientColor1 = color;
        this.cardTexts.pallete.headColor = `linear-gradient(45deg, ${color}, ${this.headerGradientColor2})`;
      }
    },
    updateHeaderGradientColor2(color) {
      if (color) {
        this.headerGradientColor2 = color;
        this.cardTexts.pallete.headColor = `linear-gradient(45deg, ${this.headerGradientColor1}, ${color})`;
      }
    },
    updateBodyGradientColor1(color) {
      if (color) {
        this.bodyGradientColor1 = color;
        this.cardTexts.pallete.bodyColor = `linear-gradient(45deg, ${color}, ${this.bodyGradientColor2})`;
      }
    },
    updateBodyGradientColor2(color) {
      if (color) {
        this.bodyGradientColor2 = color;
        this.cardTexts.pallete.bodyColor = `linear-gradient(45deg, ${this.bodyGradientColor1}, ${color})`;
      }
    },
    updateHeaderGradientPalette() {
      if (this.headerGradientPalette.type === "color") {
        this.headerGradientColor1 = this.headerGradientPalette.color;
        this.cardTexts.pallete.headColor = this.headerGradientPalette.color;
      } else {
        this.headerGradientColor1 =
          this.headerGradientPalette.gradient.colors[0];
        this.headerGradientColor2 =
          this.headerGradientPalette.gradient.colors[1];
        this.cardTexts.pallete.headColor = `linear-gradient(${this.headerGradientPalette.gradient.direction}, ${this.headerGradientPalette.gradient.colors[0]}, ${this.headerGradientPalette.gradient.colors[1]})`;
      }
    },
    updateBodyGradientPalette() {
      if (this.bodyGradientPalette.type === "color") {
        this.bodyGradientColor1 = this.bodyGradientPalette.color;
        this.cardTexts.pallete.bodyColor = this.bodyGradientPalette.color;
      } else {
        this.bodyGradientColor1 = this.bodyGradientPalette.gradient.colors[0];
        this.bodyGradientColor2 = this.bodyGradientPalette.gradient.colors[1];
        this.cardTexts.pallete.bodyColor = `linear-gradient(${this.bodyGradientPalette.gradient.direction}, ${this.bodyGradientPalette.gradient.colors[0]}, ${this.bodyGradientPalette.gradient.colors[1]})`;
      }
    },
    updateColorPalette(newPalette) {
      this.colorPalette = newPalette;
      this.cardTexts.pallete.headColor = newPalette.headerColor;
      this.cardTexts.pallete.bodyColor = newPalette.bodyColor;
      this.cardTexts.pallete.textColor = newPalette.textColor;
    },
    readerRead(file, slot = "logo") {
      if (file) {
        const reader = new FileReader();
        const _this = this;

        reader.onload = function (e) {
          const img = new Image();
          img.onload = function () {
            switch (slot) {
              case "logo":
                _this.inputChange(img);
                break;
              case "screenshot":
                _this.screenInputChange(img);
                break;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    inputChange(img) {
      const canvas144 = document.getElementById("canvas144");
      this.drawImageOnCanvasCover(canvas144, img, 144, 144);
      const canvas48 = document.getElementById("canvas48");
      this.drawImageOnCanvasCover(canvas48, img, 48, 48);
      this.uploadCanvasImage(canvas48, "48px_image.png", "icon48", "logo");
      this.uploadCanvasImage(canvas144, "144px_image.png", "icon144", "logo");
    },
    screenInputChange(img) {
      const canvasWide = document.getElementById("screenshotWide");
      this.drawImageOnCanvasCover(canvasWide, img, 1280, 720);

      const canvas600 = document.getElementById("screenshot600");
      this.drawImageOnCanvasCover(canvas600, img, 600, 400);

      this.uploadCanvasImage(
        canvasWide,
        "wide_image.png",
        "screenshotWide",
        "screenshot",
      );
      this.uploadCanvasImage(
        canvas600,
        "600_image.png",
        "screenshot600",
        "screenshot",
      );
    },
    checkVideo() {
      let search = this.perfix_business;
      //https://qr-api.terminalads.com/api/user/aparat?default=1&page=1&length=100&search=""
      this.$api
        .get(`/user/aparat?default=1&page=1&length=10000&search=${search}`)
        .then(({ data }) => {
          if (data?.data?.length > 0) {
            //for title
            this.cardTexts.video_gallery = [
              {
                name: "گالری ویدئو",
                images: [
                  {
                    name: data.data[0].title,
                    title: data.data[0].title,
                    url: data.data[0].file_link,
                    file_link: data.data[0].file_link,
                    description: "",
                    link: data.data[0].file_link,
                    id: data.data[0].id,
                  },
                ],
              },
            ];
          } else {
            search = this.Textbusiness;
            this.$api
              .get(
                `/user/aparat?default=1&page=1&length=10000&search=${search}`,
              )
              .then(({ data }) => {
                if (data?.data?.length > 0) {
                  //for text
                  this.cardTexts.video_gallery = [
                    {
                      name: "گالری ویدئو",
                      images: [
                        {
                          name: data.data[0].title,
                          title: data.data[0].title,
                          url: data.data[0].file_link,
                          file_link: data.data[0].file_link,
                          description: "",

                          link: data.data[0].file_link,
                          id: data.data[0].id,
                        },
                      ],
                    },
                  ];
                } else {
                  //welcome
                  this.cardTexts.video_gallery = [
                    {
                      name: "گالری ویدئو",
                      images: [
                        {
                          name: "خوش آمدگویی",
                          title: "",
                          url: "https://www.aparat.com/video/video/embed/videohash/a89rkt7/vt/frame",
                          file_link: "https://www.aparat.com/v/a89rkt7",
                          description: "",
                          link: "https://www.aparat.com/v/a89rkt7",
                          id: 15,
                        },
                      ],
                    },
                  ];
                }
              })
              .finally(() => {});
          }
        })
        .finally(() => {});
    },
    drawImageOnCanvasCover(canvas, img, width, height) {
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;

      const scale = Math.max(width / img.width, height / img.height);
      const scaledWidth = img.width * scale;
      const scaledHeight = img.height * scale;

      const x = (width - scaledWidth) / 2;
      const y = (height - scaledHeight) / 2;

      ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
    },
    uploadCanvasImage(canvas, filename, field, type) {
      if (type === "logo") {
        this.logoLoading = true;
      } else if (type === "screenshot") {
        this.screenshotLoading = true;
      }

      const imageDataUrl = canvas.toDataURL("image/png");
      const base64String = imageDataUrl.replace("data:image/png;base64,", "");
      const mimeType = "application/octet-stream";
      const fileBlob = base64ToBlob(base64String, mimeType);

      saveOnCdnFiles(
        fileBlob,
        filename.replace(/ /g, "_"),
        "تصاویر وب اپلیکیشن",
      )
        .then(({ data }) => {
          this.$toast.success("تصویر با موفقیت آپلود شد");
          this.cardTexts.advanceSettings.manifest[field] = data.data.link;
          if (type === "logo" && field === "icon144")
            this.cardTexts.photo.profile = data.data.link;
          if (type === "screenshot" && field === "screenshotWide") {
            this.cardTexts.photo.headBackground = data.data.link;
          }
        })
        .catch((err) => {
          // this.$toast.warn(
          //   "آپلود تصویر با مشکل روبرو شد. لطفا مجدد بارگذاری کنید"
          // );
          if (type === "logo") {
            this.logoLoading = false;
          }
          if (type === "screenshot") {
            this.screenshotLoading = false;
          }
        })
        .finally(() => {
          if (type === "logo") {
            this.logoLoading = false;
          }
          if (type === "screenshot") {
            this.screenshotLoading = false;
          }
          this.logoLoading = false;
          this.screenshotLoading = false;
        });
    },
  },
};
</script>

<style scoped>
/* new - Advanced Settings Button Styles */
.icon2 {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-right: 0px;
  margin-right: 0px;
}
.icon {
  justify-content: right;
  display: flex;
  padding-right: 0px;
  margin-right: 0px;
}

/* new - Advanced Settings Button Styles */
.advanced-settings-btn {
  transition: all 0.3s ease;
  border-radius: 8px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.advanced-settings-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* new - Submit Button Styles */
.submit-btn {
  min-width: 200px;
  height: 48px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* new - Building List Item Styles */
.building-list-item {
  border-radius: 12px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: white;
}

.building-list-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.font-family-monospace {
  font-family: "Courier New", monospace;
}

/* new - Notification Banner Styles */
.notification-banner {
  margin: 0 -16px;
}

.notification-alert {
  border-radius: 12px !important;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
  border-left: 4px solid #2196f3 !important;
}

.notification-content {
  flex: 1;
}

.notification-title {
  font-size: 14px;
  font-weight: 500;
  color: #1976d2;
  line-height: 1.4;
  margin-bottom: 4px;
}

.notification-subtitle {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.notification-link {
  text-decoration: none;
  color: #1976d2;
  transition: all 0.3s ease;
}

.notification-link:hover {
  color: #0d47a1;
  text-decoration: underline;
}

/* new - Building List Header Styles */
.building-list-header {
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 20px;
}

.building-list-title {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.refresh-btn {
  transition: all 0.3s ease;
  background: rgba(25, 118, 210, 0.1) !important;
}

.refresh-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: rotate(180deg);
}

/* new - Color Preview Styles */
.color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 2px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.color-code-field {
  max-width: 120px;
}

.copy-btn {
  margin-left: 4px;
}
</style>
